// src/EquipmentPage.jsx
import React, { useState, useEffect } from 'react';
import { Button, Modal, Input, Form} from 'antd';
import 'antd/dist/reset.css';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';                   
import { isEqual } from 'lodash';

// ---------- импортируем наши новые компоненты ----------
import EquipmentTable from '../components/EquipmentTable';
import HistoryModal from '../components/HistoryModal';
import ActionModal from '../components/ActionModal';
import EditModalMainEngineer from '../components/EditModalMainEngineer';
import EditModalChamp from '../components/EditModalChamp';
import AddEquipmentModal from '../components/AddEquipmentModal';
import SummaryBar from '../components/SummaryBar'; // (если у вас есть SummaryBar)
// -------------------------------------------------------

dayjs.extend(isBetween);

//const { RangePicker } = DatePicker;

const EquipmentPage = ({ userRole, API_URL }) => {
  // --------------------------- Состояния ---------------------------
  const [dataSource, setDataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [historyEquipmentId, setHistoryEquipmentId] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contactInfo] = useState('');

  // --- История
  const [historyData, setHistoryData] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [historyDateRange, setHistoryDateRange] = useState([]);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingEquipment, setEditingEquipment] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [addForm] = Form.useForm();
  //const [renderKey, setRenderKey] = useState(0); 
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [form] = Form.useForm();

  // для ActionModal
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);

  // ---------- СЧЁТЧИКИ «подстатусов» ----------
  const [okCount, setOkCount] = useState(0);

  const [to1Count, setTo1Count] = useState(0);
  const [to2Count, setTo2Count] = useState(0);
  const [to3Count, setTo3Count] = useState(0);

  const [krCount, setKrCount] = useState(0);   // КР
  const [pvCount, setPvCount] = useState(0);   // ПВ
  const [klCount, setKlCount] = useState(0);   // КЛ (калибровка)
  const [ispCount, setIspCount] = useState(0); // ИСП (испытания)

  const [redTo1Count, setRedTo1Count] = useState(0);
  const [yellowTo1Count, setYellowTo1Count] = useState(0);
  const [redTo2Count, setRedTo2Count] = useState(0);
  const [yellowTo2Count, setYellowTo2Count] = useState(0);
  const [redTo3Count, setRedTo3Count] = useState(0);
  const [yellowTo3Count, setYellowTo3Count] = useState(0);  
  const [redKrCount, setRedKrCount] = useState(0);
  const [yellowKrCount, setYellowKrCount] = useState(0);
  const [redPvCount, setRedPvCount] = useState(0);
  const [yellowPvCount, setYellowPvCount] = useState(0);
  const [redKlCount, setRedKlCount] = useState(0);
  const [yellowKlCount, setYellowKlCount] = useState(0);
  const [redIspCount, setRedIspCount] = useState(0);
  const [yellowIspCount, setYellowIspCount] = useState(0);


  // Ручные статусы
  const [onRepairCount, setOnRepairCount] = useState(0);           // "На ремонте"
  const [brokenCount, setBrokenCount] = useState(0);               // "Неисправен"
  const [waitPartsCount, setWaitPartsCount] = useState(0);         // "Ожидает зап части"
  const [writtenOffCount, setWrittenOffCount] = useState(0);       // "Списан"

  // Опции для Select (ручной статус)
  const manualStatusOptions = [
    { label: 'Нет', value: 'Нет' },
    { label: 'На ремонте', value: 'На ремонте' },
    { label: 'Ожидает зап части', value: 'Ожидает зап части' },
    { label: 'Неисправен', value: 'Неисправен' },
    { label: 'Списан', value: 'Списан' }
  ];

  // --------------------------- useEffect ---------------------------
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    fetch(`${API_URL}/equipment`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setDataSource(data);
          setFilteredData(data);
        } else {
          setDataSource([]);
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error('Ошибка при получении данных:', error);
        setDataSource([]);
        setFilteredData([]);
      });
  }, []);
  
  // --------------------------- Функции ---------------------------
  
   // 3) Подсчет «подстатусов» при каждом обновлении dataSource
   useEffect(() => {
    const currentDate = dayjs();
    const warningThreshold = currentDate.add(15, 'day');  // Даты в пределах 30 дней
  
    // Временные переменные-счётчики
    let tmpOk = 0;

    let tmpTo1 = 0, tmpRedTo1 = 0, tmpYellowTo1 = 0;
    let tmpTo2 = 0, tmpRedTo2 = 0, tmpYellowTo2 = 0;
    let tmpTo3 = 0, tmpRedTo3 = 0, tmpYellowTo3 = 0;
  
    let tmpKr = 0, tmpRedKr = 0, tmpYellowKr = 0;
    let tmpPv = 0, tmpRedPv = 0, tmpYellowPv = 0;
    let tmpKl = 0, tmpRedKl = 0, tmpYellowKl = 0;
    let tmpIsp = 0, tmpRedIsp = 0, tmpYellowIsp = 0;
  
    let tmpOnRepair = 0, tmpBroken = 0, tmpWaitParts = 0, tmpWrittenOff = 0;
  
    const isRedOrYellow = (date) => {
      if (!date) return false;
      const targetDate = dayjs(date);
      return targetDate.isBefore(currentDate) || targetDate.isBefore(warningThreshold);
    };
  
    dataSource.forEach((record) => {
      // --- ТО1 ---
      if (record.to1 && isRedOrYellow(record.to1)) {
        tmpTo1++;  // Считаем "всего" только если красная или жёлтая дата
        const to1Date = dayjs(record.to1);
        if (to1Date.isBefore(currentDate)) tmpRedTo1++;
        else if (to1Date.isBefore(warningThreshold)) tmpYellowTo1++;
      }
  
      // --- ТО2 ---
      if (record.to2 && isRedOrYellow(record.to2)) {
        tmpTo2++;
        const to2Date = dayjs(record.to2);
        if (to2Date.isBefore(currentDate)) tmpRedTo2++;
        else if (to2Date.isBefore(warningThreshold)) tmpYellowTo2++;
      }
  
      // --- ТО3 ---
      if (record.to3 && isRedOrYellow(record.to3)) {
        tmpTo3++;
        const to3Date = dayjs(record.to3);
        if (to3Date.isBefore(currentDate)) tmpRedTo3++;
        else if (to3Date.isBefore(warningThreshold)) tmpYellowTo3++;
      }
  
      // --- Капитальный ремонт ---
      if (record.majorRepair && isRedOrYellow(record.majorRepair)) {
        tmpKr++;
        const repairDate = dayjs(record.majorRepair);
        if (repairDate.isBefore(currentDate)) tmpRedKr++;
        else if (repairDate.isBefore(warningThreshold)) tmpYellowKr++;
      }
  
      // --- Поверка ---
      if (record.verification && isRedOrYellow(record.verification)) {
        tmpPv++;
        const verificationDate = dayjs(record.verification);
        if (verificationDate.isBefore(currentDate)) tmpRedPv++;
        else if (verificationDate.isBefore(warningThreshold)) tmpYellowPv++;
      }
  
      // --- Калибровка ---
      if (record.calibration && isRedOrYellow(record.calibration)) {
        tmpKl++;
        const calibrationDate = dayjs(record.calibration);
        if (calibrationDate.isBefore(currentDate)) tmpRedKl++;
        else if (calibrationDate.isBefore(warningThreshold)) tmpYellowKl++;
      }
  
      // --- Испытания ---
      if (record.testing && isRedOrYellow(record.testing)) {
        tmpIsp++;
        const testingDate = dayjs(record.testing);
        if (testingDate.isBefore(currentDate)) tmpRedIsp++;
        else if (testingDate.isBefore(warningThreshold)) tmpYellowIsp++;
      }
  
      // --- Мануальные статусы ---
      const statuses = record.status ? record.status.split(',').map(s => s.trim()) : [];
      statuses.forEach((subStatus) => {
        switch (subStatus) {
          case 'ОК':
            tmpOk++;  // Считаем "ОК"
            break;
          case 'На ремонте':
            tmpOnRepair++;
            break;
          case 'Неисправен':
            tmpBroken++;
            break;
          case 'Ожидает зап части':
            tmpWaitParts++;
            break;
          case 'Списан':
            tmpWrittenOff++;
            break;
          default:
            break;
        }
      });
    });
  
    // Обновляем состояние с подсчётом
    setOkCount(tmpOk);  // Обновляем счётчик "ОК"

    setTo1Count(tmpTo1);
    setRedTo1Count(tmpRedTo1);
    setYellowTo1Count(tmpYellowTo1);
  
    setTo2Count(tmpTo2);
    setRedTo2Count(tmpRedTo2);
    setYellowTo2Count(tmpYellowTo2);
  
    setTo3Count(tmpTo3);
    setRedTo3Count(tmpRedTo3);
    setYellowTo3Count(tmpYellowTo3);
  
    setKrCount(tmpKr);
    setRedKrCount(tmpRedKr);
    setYellowKrCount(tmpYellowKr);
  
    setPvCount(tmpPv);
    setRedPvCount(tmpRedPv);
    setYellowPvCount(tmpYellowPv);
  
    setKlCount(tmpKl);
    setRedKlCount(tmpRedKl);
    setYellowKlCount(tmpYellowKl);
  
    setIspCount(tmpIsp);
    setRedIspCount(tmpRedIsp);
    setYellowIspCount(tmpYellowIsp);
  
    // Мануальные статусы
    setOnRepairCount(tmpOnRepair);
    setBrokenCount(tmpBroken);
    setWaitPartsCount(tmpWaitParts);
    setWrittenOffCount(tmpWrittenOff);
  }, [dataSource]);

  // Пример модалки контакта\
  /*
  const showModal = (contact) => {
    setContactInfo(contact);
    setIsModalOpen(true);
  };*/

  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  // Клик по названию (логика роли)
  const handleNameClick = (record) => {
    form.resetFields(); // Обнулить форму перед открытием (дополнительно, если нужно)
    // Форматируем даты под dayjs-формат
    const formattedRecord = {
      ...record,
      to1: record.to1 ? dayjs(record.to1) : null,
      to2: record.to2 ? dayjs(record.to2) : null,
      to3: record.to3 ? dayjs(record.to3) : null,
      majorRepair: record.majorRepair ? dayjs(record.majorRepair) : null,
      verification: record.verification ? dayjs(record.verification) : null,
      calibration: record.calibration ? dayjs(record.calibration) : null,
      testing: record.testing ? dayjs(record.testing) : null,
      to1Frequency: record.to1Frequency || null,
      to2Frequency: record.to2Frequency || null,
      to3Frequency: record.to3Frequency || null,
      majorRepairFrequency: record.majorRepairFrequency || null,
      verificationFrequency: record.verificationFrequency || null,
      calibrationFrequency: record.calibrationFrequency || null,
      testingFrequency: record.testingFrequency || null,
      manualStatus: record.manualStatus || 'Нет',
    };

    if (userRole === 'engineer') {
      setSelectedEquipment(record);
      setIsActionModalOpen(true);
    } else if (userRole === 'main_engineer') {
      setEditingEquipment(formattedRecord);
      setIsEditModalOpen(true);
    } else {
      // 'champ' или другие
      setEditingEquipment(formattedRecord);
      setIsEditModalOpen(true);
    }
  };

  // Функция для отслеживания изменений формы (активация кнопки "Сохранить")
  const handleValuesChange = (_, allValues) => {
    const isChanged = !isEqual(initialValues, allValues);
    setIsSaveDisabled(!isChanged);
  };

  useEffect(() => {
    if (editingEquipment) {
      form.setFieldsValue(editingEquipment);
    }
  }, [editingEquipment, form]);

// Сохранение для роли champ
const handleEditOk = (values) => {
  // 1) Собираем новые данные
  const updatedData = {
    ...editingEquipment,
    ...values,
    to1: values.to1 ? values.to1.format('YYYY-MM-DD') : null,
    to2: values.to2 ? values.to2.format('YYYY-MM-DD') : null,
    to3: values.to3 ? values.to3.format('YYYY-MM-DD') : null,
    majorRepair: values.majorRepair ? values.majorRepair.format('YYYY-MM-DD') : null,
    verification: values.verification ? values.verification.format('YYYY-MM-DD') : null,
    calibration: values.calibration ? values.calibration.format('YYYY-MM-DD') : null,
    testing: values.testing ? values.testing.format('YYYY-MM-DD') : null,
    manualStatus: values.manualStatus || 'Нет',
    location: values.location || '',
  };

  // 2) Если выставили manualStatus, то требуем обязательный комментарий
  if (values.manualStatus !== 'Нет' && !values.comment?.trim()) {
    alert("Комментарий обязателен при изменении мануального статуса.");
    return;
  }

  // 3) Находим реально изменённые поля, чтобы отправлять только их
  const changedValues = {};
  Object.keys(updatedData).forEach((key) => {
    const oldValue = editingEquipment[key];
    const newValue = updatedData[key];

    // Для дат сравниваем строковое представление
    if (dayjs.isDayjs(oldValue) || dayjs.isDayjs(newValue)) {
      const oldDate = oldValue ? dayjs(oldValue).format('YYYY-MM-DD') : null;
      const newDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
      if (oldDate !== newDate) {
        changedValues[key] = newDate;
      }
    }
    // Для всех остальных типов — обычное сравнение
    else if (oldValue !== newValue) {
      changedValues[key] = newValue;
    }
  });

  if (Object.keys(changedValues).length === 0) {
    alert('Изменений нет');
    return;
  }

  // 4) Отправляем данные на сервер
  setIsUpdating(true);
  fetch(`${API_URL}/edit_equipment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({
      id: editingEquipment.id,
      newValues: changedValues,
      comment: values.comment, // передаём комментарий
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        // 5) После успеха — сразу подгружаем с сервера обновлённую запись
        fetch(`${API_URL}/equipment/${editingEquipment.id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        })
          .then((res) => res.json())
          .then((updatedRow) => {
            // 6) Обновляем локальные данные для таблицы
            setDataSource((prev) =>
              prev.map((item) =>
                item.id === editingEquipment.id ? { ...item, ...updatedRow } : item
              )
            );
            setFilteredData((prev) =>
              prev.map((item) =>
                item.id === editingEquipment.id ? { ...item, ...updatedRow } : item
              )
            );

            // 7) Закрываем модалку и сбрасываем состояние
            setIsEditModalOpen(false);
            setEditingEquipment(null);

            // (необязательно) Сбросим поля формы:
            form.resetFields();
          })
          .catch((error) => console.error('Ошибка при получении обновлённой строки:', error));
      } else {
        console.error('Ошибка на сервере:', data.message || 'Неизвестная ошибка');
      }
    })
    .catch((error) => {
      console.error('Ошибка при редактировании оборудования:', error);
    })
    .finally(() => setIsUpdating(false));
};


  // Инициализация начальных значений
  useEffect(() => {
    if (editingEquipment) {
      const formattedValues = {
        name: editingEquipment.name,
        manufacturer: editingEquipment.manufacturer,
        serialNumber: editingEquipment.serialNumber,
        qrLink: editingEquipment.qrLink,
        manualLink: editingEquipment.manualLink,
        location: editingEquipment.location,
        manualStatus: editingEquipment.manualStatus,
      };
      setInitialValues(formattedValues);
      form.setFieldsValue(formattedValues);
    }
  }, [editingEquipment, form]);

  const handleEditCancel = () => {
    form.resetFields();        // Сброс формы
    setIsEditModalOpen(false); // Закрываем модалку
    setEditingEquipment(null); // Сбрасываем текущее оборудование
  };

  // Пример полноценного хендлера ДЛЯ ГЛАВНОГО ИНЖЕНЕРА:
const handleEditMainEngineer = (values) => {
  // 1) Собираем новые данные из формы
  const updatedData = {
    ...editingEquipment,
    ...values,
    // Если manualStatus не указан, ставим пустую строку, 
    //   чтобы избежать undefined
    manualStatus: values.manualStatus || 'Нет',
    // Аналогично для location, если нужно:
    location: values.location || '',
    // Преобразуем DatePicker в 'YYYY-MM-DD':
    to1: values.to1 ? values.to1.format('YYYY-MM-DD') : null,
    to2: values.to2 ? values.to2.format('YYYY-MM-DD') : null,
    to3: values.to3 ? values.to3.format('YYYY-MM-DD') : null,
    majorRepair: values.majorRepair ? values.majorRepair.format('YYYY-MM-DD') : null,
    verification: values.verification ? values.verification.format('YYYY-MM-DD') : null,
    calibration: values.calibration ? values.calibration.format('YYYY-MM-DD') : null,
    testing: values.testing ? values.testing.format('YYYY-MM-DD') : null,
  };

  // 2) Если manualStatus != 'Нет', но комментарий пуст — требуем комментарий
  if (updatedData.manualStatus !== 'Нет' && !values.comment?.trim()) {
    alert('Комментарий обязателен при изменении мануального статуса.');
    return;
  }

  // 3) Находим реально изменённые поля
  const changedValues = {};
  Object.keys(updatedData).forEach((key) => {
    const oldValue = editingEquipment[key];
    const newValue = updatedData[key];

    // Для дат сравниваем строковое представление
    if (dayjs.isDayjs(oldValue) || dayjs.isDayjs(newValue)) {
      const oldDate = oldValue ? dayjs(oldValue).format('YYYY-MM-DD') : null;
      const newDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
      if (oldDate !== newDate) {
        changedValues[key] = newDate;
      }
    } else if (oldValue !== newValue) {
      changedValues[key] = newValue;
    }
  });

  if (Object.keys(changedValues).length === 0) {
    alert('Изменений нет');
    return;
  }

  // 4) Отправляем POST-запрос на /equipment_action_main_engineer
  fetch(`${API_URL}/equipment_action_main_engineer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({
      equipment_id: editingEquipment.id,
      newValues: changedValues,
      comment: values.comment,  // Передаём комментарий
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        // 5) После успеха — делаем второй запрос: GET /equipment/:id
        fetch(`${API_URL}/equipment/${editingEquipment.id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
          .then((res) => {
            // если придёт 403, значит нет токена,
            // но мы как раз передали в заголовке: Authorization: Bearer ...
            return res.json();
          })
          .then((updatedRow) => {
            // 6) Обновляем локальный стейт
            setDataSource((prev) =>
              prev.map((item) =>
                item.id === editingEquipment.id ? { ...item, ...updatedRow } : item
              )
            );
            setFilteredData((prev) =>
              prev.map((item) =>
                item.id === editingEquipment.id ? { ...item, ...updatedRow } : item
              )
            );

            // 7) Закрываем модалку
            setIsEditModalOpen(false);
            setEditingEquipment(null);
            form.resetFields(); // очистим поля формы
          })
          .catch((error) => console.error('Ошибка при GET /equipment/id:', error));
      } else {
        console.error('Ошибка на сервере:', data.message || 'Неизвестная ошибка');
      }
    })
    .catch((error) => {
      console.error('Ошибка при редактировании оборудования:', error);
    });
};

  // Удаление
  const handleDeleteEquipment = (id) => {
    fetch(`${API_URL}/delete_equipment/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setDataSource((prev) => prev.filter((item) => item.id !== id));
          setFilteredData((prev) => prev.filter((item) => item.id !== id));
          setIsEditModalOpen(false);
        } else {
          console.error('Ошибка сервера:', data.message);
        }
      })
      .catch((error) => console.error('Ошибка при удалении оборудования:', error));
  };

 // --- Загрузка истории и показ модалки
 const showHistoryModal = (equipmentId) => {
  setHistoryEquipmentId(equipmentId);     // <-- Запоминаем ID в новом стейте
  const token = localStorage.getItem('token');
  fetch(`${API_URL}/get_history/${equipmentId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
    .then((response) => response.json())
    .then((history) => {
      setHistoryData(history);
      setIsHistoryModalOpen(true);
    })
    .catch((error) => {
      console.error('Ошибка при получении истории:', error);
    });
};

  

  // --- РЕДАКТИРОВАНИЕ КОММЕНТАРИЯ (comment_edit)
  // ... ваш код
  const onEditComment = (historyId, newComment) => {
    fetch(`${API_URL}/edit_comment/${historyId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ newComment }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          alert('Комментарий успешно отредактирован!');
  
          // Если у нас есть historyEquipmentId – перезагрузим историю именно того оборудования
          if (historyEquipmentId) {
            showHistoryModal(historyEquipmentId);
          }
        } else {
          console.error('Ошибка редактирования:', data.error || 'Неизвестно');
        }
      })
      .catch(err => console.error('Ошибка сети:', err));
  };
  

// ...

  

  // Фильтр истории по дате
  const filterHistoryByDate = () => {
    if (historyDateRange && historyDateRange.length === 2) {
      const [startDate, endDate] = historyDateRange;
      return historyData.filter((history) => {
        const historyDate = dayjs(history.timestamp, 'DD-MM-YYYY HH:mm:ss');
        return historyDate.isBetween(startDate, endDate, 'day', '[]');
      });
    }
    return historyData;
  };

// Пример кода в вашем родителе, где handleActionSubmit
const handleActionSubmit = async (requests) => {
  const token = localStorage.getItem('token');

  for (const req of requests) {
    // 1) formData
    const formData = new FormData();
    formData.append('equipment_id', selectedEquipment.id);

    if (req.action) {
      formData.append('action', req.action);
    }
    if (req.manualStatus) {
      formData.append('manualStatus', req.manualStatus);
    }
    formData.append('comment', req.comment || 'Без комментария');

    // Прикрепляем именно req.photoFiles
    if (req.photoFiles && req.photoFiles.length > 0) {
      for (const file of req.photoFiles) {
        formData.append('photos', file);
      }
    }

    try {
      const response = await fetch(`${API_URL}/equipment_action`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Ошибка при выполнении действия');
      }

      // Обновить локальный dataSource
      setDataSource((prev) =>
        prev.map((item) =>
          item.id === selectedEquipment.id
            ? { ...item, ...data.updated_dates }
            : item
        )
      );
      setFilteredData((prev) =>
        prev.map((item) =>
          item.id === selectedEquipment.id
            ? { ...item, ...data.updated_dates }
            : item
        )
      );

    } catch (error) {
      console.error(error);
      alert(error.message);
      break;
    }
  }

  setIsActionModalOpen(false);
};

  // Поиск
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = dataSource.filter((record) => {
      const name = record.name || '';
      const manufacturer = record.manufacturer || '';
      const serialNumber = record.serialNumber || '';
      return (
        name.toLowerCase().includes(value.toLowerCase()) ||
        manufacturer.toLowerCase().includes(value.toLowerCase()) ||
        serialNumber.toLowerCase().includes(value.toLowerCase())
      );
    });
    setFilteredData(filtered);
  };

  const resetSearch = () => {
    setSearchText('');
    setFilteredData(dataSource);
  };

  // Модалка «Добавить оборудование»
  const showAddModal = () => {
    setIsAddModalOpen(true);
  };
  const handleAddCancel = () => {
    setIsAddModalOpen(false);
    form.resetFields();
  };

  const handleAddEquipment = (values) => {
    const newEquipment = {
      ...values,
      to1: values.to1 ? values.to1.format('YYYY-MM-DD') : null,
      to2: values.to2 ? values.to2.format('YYYY-MM-DD') : null,
      to3: values.to3 ? values.to3.format('YYYY-MM-DD') : null,
      majorRepair: values.majorRepair ? values.majorRepair.format('YYYY-MM-DD') : null,
      verification: values.verification ? values.verification.format('YYYY-MM-DD') : null,
      calibration: values.calibration ? values.calibration.format('YYYY-MM-DD') : null,
      testing: values.testing ? values.testing.format('YYYY-MM-DD') : null,
      to1Frequency: values.to1Frequency,
      to2Frequency: values.to2Frequency,
      to3Frequency: values.to3Frequency,
      majorRepairFrequency: values.majorRepairFrequency,
      verificationFrequency: values.verificationFrequency,
      calibrationFrequency: values.calibrationFrequency,
      testingFrequency: values.testingFrequency,
    };

    fetch(`${API_URL}/add_equipment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(newEquipment),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const newRow = {
            ...newEquipment,
            id: data.id,
            to1: data.to1,
            to2: data.to2,
            to3: data.to3,
            majorRepair: data.majorRepair,
            verification: data.verification,
            calibration: data.calibration,
            testing: data.testing,
            status: data.status,
          };
          setDataSource((prev) => [...prev, newRow]);
          setFilteredData((prev) => [...prev, newRow]);
          setIsAddModalOpen(false);
          addForm.resetFields();
        } else {
          console.error('Ошибка добавления оборудования:', data.error || 'Неизвестная ошибка');
        }
      })
      .catch((error) => console.error('Ошибка при добавлении оборудования:', error));
  };

  // Проверка защищённого роута (демо)
  fetch(`${API_URL}/protected-route`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error('Error:', error));

  // --------------------- Рендер ---------------------
  return (
    <div style={{ padding: 16 }}>
    {/* 
      1) Сюда вставляем SummaryBar, 
         передаём все наши счётчики:
    */}
    <SummaryBar
    okCount={okCount}
    to1Count={to1Count} redTo1Count={redTo1Count} yellowTo1Count={yellowTo1Count}
    to2Count={to2Count} redTo2Count={redTo2Count} yellowTo2Count={yellowTo2Count}
    to3Count={to3Count} redTo3Count={redTo3Count} yellowTo3Count={yellowTo3Count}
    krCount={krCount} redKrCount={redKrCount} yellowKrCount={yellowKrCount}
    pvCount={pvCount} redPvCount={redPvCount} yellowPvCount={yellowPvCount}
    klCount={klCount} redKlCount={redKlCount} yellowKlCount={yellowKlCount}
    ispCount={ispCount} redIspCount={redIspCount} yellowIspCount={yellowIspCount}
    onRepairCount={onRepairCount} brokenCount={brokenCount}
    waitPartsCount={waitPartsCount} writtenOffCount={writtenOffCount}
    />
      <h1>Список оборудования</h1>

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: 16 }}>
        <Input.Search
          placeholder="Поиск по Наименованию, Производителю, Серийному номеру"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
          style={{ width: 300 }}
        />
        <Button onClick={resetSearch} style={{ marginLeft: 8 }}>
          Сбросить
        </Button>
        {(userRole === 'champ' || userRole === 'main_engineer') && (
          <Button type="primary" onClick={showAddModal} style={{ marginLeft: 16 }}>
            Добавить оборудование
          </Button>
          )}
      </div>

      {/* ---------- Таблица ---------- */}
      <EquipmentTable
        filteredData={filteredData}
        handleNameClick={handleNameClick}
        showHistoryModal={showHistoryModal} // передаём для "Посмотреть историю"
      />

      {/* ---------- Модалки ---------- */}
      <Modal 
        title="Контакты производителя" 
        open={isModalOpen} 
        onOk={handleOk} 
        onCancel={handleCancel}
      >
        <p>{contactInfo}</p>
      </Modal>

      <HistoryModal
        isHistoryModalOpen={isHistoryModalOpen}
        setIsHistoryModalOpen={setIsHistoryModalOpen}
        historyDateRange={historyDateRange}
        setHistoryDateRange={setHistoryDateRange}
        filterHistoryByDate={filterHistoryByDate}
        userRole={userRole}


        // --- ПЕРЕДАЁМ историю и колбэк:
        historyData={historyData}
        onEditComment={onEditComment} 
      />

      <ActionModal
        isActionModalOpen={isActionModalOpen}
        setIsActionModalOpen={setIsActionModalOpen}
        handleActionSubmit={handleActionSubmit}
        selectedEquipment={selectedEquipment}  // <-- ВАЖНО! Пробрасываем
      />

      <EditModalMainEngineer
        isEditModalOpen={isEditModalOpen && userRole === 'main_engineer'}
        editingEquipment={editingEquipment}
        handleEditCancel={handleEditCancel}
        handleEditMainEngineer={handleEditMainEngineer}
        form={form}
        manualStatusOptions={manualStatusOptions}
      />

      <EditModalChamp
        isEditModalOpen={isEditModalOpen && userRole === 'champ'}
        editingEquipment={editingEquipment}
        handleEditCancel={handleEditCancel}
        handleEditOk={handleEditOk}
        form={form}
        handleValuesChange={handleValuesChange}
        isSaveDisabled={isSaveDisabled}
        userRole={userRole}
        handleDeleteEquipment={handleDeleteEquipment}
        manualStatusOptions={manualStatusOptions}
      />

      <AddEquipmentModal
        isAddModalOpen={isAddModalOpen}
        handleAddCancel={handleAddCancel}
        addForm={addForm}
        handleAddEquipment={handleAddEquipment}
      />
    </div>
  );
};

export default EquipmentPage;
